import Dexie, { type Table } from 'dexie';

export interface DBDelivererOrder {
    id: string;
    number: string;
    status: string;
    channel: string;
    customer_name: string | null;
    delivery_address: {
        line1: string;
        neighborhood: string;
        zip: string;
        lat: number | null;
        lng: number | null;
        full: string;
        note?: string;
        distance_km?: number | null;
    };
    delivery_token_hash: string;
    requires_token: boolean;
    requires_photo: boolean;
    items: { name: string; quantity: number }[];
    payment_method: string;
    payment_amount: number;
    payment_on_delivery: boolean;
    assigned_at: string;
    cached_at: number; // unix ms
}

export interface DBOfflineConfirmation {
    localId?: number; // auto-increment primary key
    id: string;       // order UUID
    token: string | null;
    confirmed_at: string;
    gps_lat: number;
    gps_lng: number;
    synced: boolean;
}

class DelivererDB extends Dexie {
    deliverer_orders!: Table<DBDelivererOrder, string>;
    offline_confirmations!: Table<DBOfflineConfirmation, number>;

    constructor() {
        super('ze_deliverer');
        this.version(1).stores({
            deliverer_orders:      'id, status',
            offline_confirmations: '++localId, id, synced',
        });
    }
}

export const db = new DelivererDB();
